/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { POPUP_SETTINGS_RTL as d, POPUP_SETTINGS as e } from "../consts.mjs";
import { isIdZeroLevel as w } from "./itemsIdsUtils.mjs";
function f(r, n, t) {
  const o = i(r, n, t);
  return t ? o === "downward" ? d.downward : d.leftward : o === "downward" ? e.downward : e.rightward;
}
function i(r, n, t) {
  return w(r) ? n ? t ? "leftward" : "rightward" : "downward" : t ? "leftward" : "rightward";
}
function l(r) {
  return r ? "rtl" : "ltr";
}
function P(r, n) {
  return `${r}_${n}`;
}
export {
  l as convertBoolDirectionToString,
  i as getChildrenPosition,
  P as getDOMElementId,
  f as getPopupSettings
};
